import React, { useState, useEffect, useRef, RefObject } from 'react';
import { getResourceString } from '../../kentico/resource-strings';
import _ from 'lodash';
import ReactHtmlParser from "react-html-parser";
import { ValidationControlHelper } from '../helpers/ValidationControlHelper';
import { RenderStep } from '../components/FormControlRendering';
import { createPortal } from 'react-dom';
import { Lidmaatschap, LidmaatschapService } from '@fnv-core/services/lidmaatschap.service';
import { ContributionHelper } from '../helpers/ContributionHelper';
import { WidgetFormProps } from '../WidgetForm';

export const ContributieBeslisboomWidgetForm: React.FC<WidgetFormProps> = (state) => {

  const [contentData, setContentData] = useState<ContentData>(null);
  const [lidmaatschap, setlidmaatschap] = useState<Lidmaatschap>(null);
  const [prevContributionBody, setPrevContributionBody] = useState<ContributionRateData>(null);
  const [contribution, setContribution] = useState<ContributionRate>(null);

  const lidmaatschapService: LidmaatschapService = new LidmaatschapService();
  
  if(state.fields.length > 0 && state.formLoading) {
    setTimeout(() => {
      state.setFormLoading(false);
    }, 1000);
  }
  
  useEffect(() => {
    
    state.setFieldManipulations(() => ContributionHelper.getFieldManipulationsIntroductionContribution(state));

    state.initForms(state.formDefinitions);

    const contentData: ContentData = {
      introText: state.props.summaryIntro
    };
    setContentData(contentData);
  }, []);

  useEffect(() => {

    if(state.formData["PersoonId"] && !lidmaatschap) {
      lidmaatschapService.GetLidmaatschapData<Lidmaatschap>(state.formData["PersoonId"].value).then((data) => {
        setlidmaatschap(data);
      })
    }

    if(ValidationControlHelper.validateField(state.fields, "Geboortedatum", state.formData, state.setFormData, state.handleNewFormData, true)?.length == 0) {
      ContributionHelper.getContribution(state, prevContributionBody, setPrevContributionBody).then((response) => {
        if(response != null) {
          setContribution(response.data);
        }
      });
    }
   
  }, [state.formData]);

  const RenderContent = ({windowWidth, contribution}) => {

    if(windowWidth <= 769) {
      document.body.style.paddingBottom = "175px";
    }
    else {
      document.body.style.paddingBottom = null;
    }

    return (
      <div className={`fnv-form-content__wrapper sticky sticky__top${windowWidth >= 1025 ? '-5' : '-60' } fixed-md pt-2`}>
  
        <div className="fnv-form-content fnv-form-content__membership p-3">
          <p className="content__intro">
            <b>{getResourceString("Form.ContributieCheck.Lidmaatschap.Label")}</b>
          </p>
          <div className="discount-text">
            <span>{getResourceString("Form.ContributieCheck.Lidmaatschap.Now")}</span>
            <span>
              €{lidmaatschap?.ContributionAmount?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) ?? "-.--"} p/m
            </span>
          </div>
          <div className="discount-text">
            <span className="discount-text__highlighted">{getResourceString("Form.ContributieCheck.Lidmaatschap.After")}</span>
            <span className="discount-text__highlighted green">
              €{contribution?.price?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) ?? "-.--"} p/m
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {state.beforeFormRef?.current &&
        createPortal(
        <>
          {state.currentStepIndex == 0 && (
            <div className="fnv-form-content fnv-form-content__container mt-2">
              {!ValidationControlHelper.isNullOrEmpty(contentData?.introText) && (
                <p className="content__intro">{ReactHtmlParser(contentData.introText)}</p>
              )}
            </div>
          )}
        </>,
        state.beforeFormRef.current
      )}

      <div className="col-12 col-sm p-0" ref={state.formFieldsRef}> 
        {!state.formLoading && <RenderStep
            fields={state.fields}
            formDefinition={state.formDefinitions} 
            visibleFields={state.visibleFields} 
            currentStepIndex={state.currentStepIndex} 
            formData={state.formData} 
            setFormData={state.setFormData}
            formErrors={state.formErrors} 
            handleChange={state.handleChange} 
            handleBlur={state.handleBlur}
            formSummaryData={null}
            navigateToStep={state.setHandleFormStepSpecific}
          />
        }
      </div>

      {state.sidebarRef.current &&
      createPortal(
        <div className="form-redesign h-100">
          <RenderContent windowWidth={state.windowWidth} contribution={contribution} />
        </div>,
        state.sidebarRef.current
      )
    }
    </>
  );
};

export default ContributieBeslisboomWidgetForm;